module.exports = __webpack_public_path__ + "img/FLSH6.4cbf7634.svg";